import { memo, useCallback, useEffect, useState } from 'react';
import { Typography, Input, Tooltip, message } from 'antd';
import { debounce } from 'lodash';

const DebounceInput = ({ searchName, setSearchName, style, placeholder, size, allowClear }) => {
    const [searchText, setSearchText] = useState('');

    const updateFilter = useCallback(
        debounce(() => {
            setSearchName(searchText);
        }, 500),
        [searchText]
    );

    useEffect(() => {
        setSearchText(searchName);
    }, [searchName]);

    const handleNameChange = e => {
        setSearchText(e);
    };

    useEffect(() => {
        if (searchName !== searchText) {
            updateFilter();
        }

        return () => updateFilter.cancel();
    }, [updateFilter, searchText]);

    return (
        <div className="" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <Input
                value={searchText}
                onChange={e => {
                    handleNameChange(e.target.value);
                }}
                className="name-filter"
                placeholder={placeholder}
                size={size}
                style={{ marginRight: '10px', maxHeight: '150px', ...style }}
                allowClear={allowClear}
            />
        </div>
    );
};

export default memo(DebounceInput);
